import axios from "axios";
import Cookies from "js-cookie";
import { mainBaseUrl } from "@/apis/appconst";

const apiBaseUrl = mainBaseUrl + "api/v1";

export const api = axios.create({
  baseURL: apiBaseUrl,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const handleError = (error) => {
  return {
    success: false,
    type: "error",
    message:
      error?.response?.data?.message || 
      error?.response?.data?.error || 
      "Something went wrong",
    response: error?.response?.data || null,
  };
};

